export default "__VITE_ASSET__DaLj415d__"